<template>
  <div class="table-responsive">
    <table
      style="width:100%"
      class="table table-head-custom table-head-bg table-borderless table-vertical-center"
    >
      <thead>
        <tr>
          <th class="pl-10">نام مقصد</th>
          <th>شروع</th>
          <th>پایان</th>
          <th>مدت</th>
          <th>توضیحات</th>
          <th style="width:30%">دیدگاه ها</th>
          <!-- <th>بازدیدکنند ه ها</th> -->
        </tr>
      </thead>
      <tbody>
        <tr
          scope="row"
          v-for="liveDestination in liveDestinations"
          :key="`lc-${liveDestination.id}`"
          class="mt-3"
        >
          <td>
            <router-link
              :to="{
                name: 'live-destinations-show',
                params: { id: liveDestination.id }
              }"
            >
              <div class="w-auto btn-clean d-flex px-2">
                <span class="symbol symbol-25 symbol-light-success">
                  <img
                    :alt="liveDestination.name"
                    :src="liveDestination.image"
                  />
                  <i class="symbol-badge" :class="liveDestination.badge"></i>
                </span>
                <span class="ml-3 font-size-lg pt-1">
                  {{ liveDestination.name }}
                </span>
              </div>
            </router-link>
          </td>
          <td dir="ltr" class="text-nowrap ">
            {{ liveDestination.start }}
          </td>
          <td dir="ltr" class="text-nowrap">
            {{ liveDestination.end }}
          </td>
          <td class="align-bottom">{{ liveDestination.length }}</td>
          <td v-if="liveDestination.visitors" class="align-bottom">
            تعداد بازدید:
            {{ liveDestination.visitors }}
          </td>
          <td
            colspan="1"
            v-if="liveDestination.error"
            class="text-danger align-bottom"
          >
            {{ liveDestination.error }}
            <button
              v-if="
                liveDestination.type === 3 &&
                  liveDestination.error ===
                    'اطلاعات ورود به حساب اشتباه است قسمت ویرایش مقصد اطلاعات ورود به حساب خود را بروزرسانی کنید.'
              "
              class="btn btn-xs btn-primary"
              @click="loginToInstagram(liveDestination.destination_id)"
            >
              ورود به اینستاگرام
            </button>
          </td>
          <td v-else class="text-danger align-bottom">
            -
          </td>
          <td class="text-nowrap">
            <span
              v-if="
                liveDestination.type === 3 && liveDestination.last_event === 0
              "
            >
              <button
                v-if="liveDestination.comment_status === '1'"
                class="btn btn-xs btn-primary"
                @click="handleComments(liveDestination.destination)"
              >
                بستن دیدگاه
              </button>
              <button
                v-if="liveDestination.comment_status === '2'"
                class="btn btn-xs btn-primary"
                @click="handleComments(liveDestination.destination)"
              >
                باز کردن دیدگاه
              </button>
              <router-link
                :to="{
                  name: 'live-destinations-show',
                  params: {
                    id: liveDestination.id,
                    program_id: program.id
                  }
                }"
                class="btn btn-xs btn-primary ml-1 "
              >
                مدیریت دیدگاه ها
              </router-link>
            </span>
            <span v-else>
              -
            </span>
          </td>
          <!-- <td
            v-if="liveDestination.visitors && liveDestination.last_event !== 0"
            class="align-bottom"
          >
            <span>
              تعداد بازدید:
              {{ liveDestination.visitors }}

              <button
                class="btn btn-xs btn-primary"
                @click="download(liveDestination.id)"
              >
                لیست بازدیدکننده ها
              </button>
            </span>
          </td> -->
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { ADD_ACTIONS } from "@/core/services/store/actions.module";
import {
  FETCH_LIVE,
  FETCH_LIVE_DESTINATIONS
} from "@/core/services/store/lives.module";
import { FETCH_PROGRAM } from "@/core/services/store/programs.module";

import { mapGetters } from "vuex";
import Swal from "sweetalert2";
import instagram from "@/core/mixins/instagram";

export default {
  name: "programs-show",
  mixins: [instagram],
  data() {
    return {
      liveLoaded: false,
      programLoaded: false,
      liveInterval: null,
      liveDuration: 0,
      timer: null,
      isCompany: this.$route.name.startsWith("company"),
      isAdmin: this.$route.name.startsWith("admin")
    };
  },
  props: ["liveDestinations"],
  components: {},

  beforeDestroy: function() {
    clearInterval(this.liveInterval);
    this.liveInterval = null;
  },
  methods: {
    setBreadcrumbs() {
      let programsRouteName = "programs-index";
      let programRouteName = "programs-show";

      let items = [];
      if (this.isCompany) {
        programsRouteName = "company-programs-index";
        programRouteName = "company-programs-show";
        items.push({
          title: this.currentUserProperty.title ?? "شرکت",
          route: { name: "company-dashboard" }
        });
      }
      if (this.isAdmin) {
        programsRouteName = "admin-programs-index";
        programRouteName = "admin-programs-show";
        items.push({
          title: "مدیریت",
          route: { name: "admin-dashboard" }
        });
      }
      items.push({ title: "برنامه‌‌ها", route: { name: programsRouteName } });
      items.push({
        title: this.live.program_id,
        route: { name: programRouteName, params: { id: this.live.program_id } }
      });
      items.push({ title: "پخش " + this.live.id });
      this.$store.dispatch(SET_BREADCRUMB, items);
    },
    setActions() {
      let links = [];

      if (this.isAdmin) {
        links = [
          {
            name: ' <i class=" flaticon-user ml-2  font-size-h5 "></i>',
            to: {
              name: "admin-users-show",
              params: { id: this.program.user_id }
            },
            class: "btn-primary"
          }
        ];
      } else if (this.isCompany) {
        links = [
          {
            name: ' <i class=" flaticon-user ml-2  font-size-h5 "></i>',
            to: {
              name: "company-users-show",
              params: { id: this.program.user_id }
            },
            class: "btn-primary"
          }
        ];
      }

      this.$store.dispatch(ADD_ACTIONS, {
        links: links
      });
    },

    liveDestinationIsStopped(liveDestination) {
      return [3, 4].includes(liveDestination.last_event);
    },
    liveDestinationIsFailed(liveDestination) {
      return liveDestination.last_event === 2;
    },
    getProgram(programId) {
      this.$store.dispatch(FETCH_PROGRAM, programId).then(() => {
        this.programLoaded = true;
        this.setActions();
      });
    },
    update(programId, liveId) {
      if (this.isFailed || this.isStopped) {
        return;
      }

      this.liveLoaded = false;

      this.$store
        .dispatch(FETCH_LIVE, liveId)
        .then(() => {
          this.liveLoaded = true;
          this.liveDuration = this.getDuration(this.live.created_at);
          this.startTimer();

          this.setBreadcrumbs();
          if (this.programLoaded) {
            this.setButtons();
          }

          if (this.isStopped || this.isFailed) {
            clearInterval(this.liveInterval);
            this.liveInterval = null;
          }
        })
        .catch(() => {
          this.liveLoaded = true;
        });
      this.$store.dispatch(FETCH_LIVE_DESTINATIONS, liveId);
    },
    handleComments(destination) {
      Swal.fire({
        title: "",
        text: "آیا مطمئن هستید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "بله",
        confirmButtonColor: "#4554a0",
        cancelButtonText: "خیر",
        cancelButtonColor: "#ed1c24",
        heightAuto: false
      }).then(result => {
        if (result.isConfirmed) {
          this.handleCommentInstagram(destination);
        }
      });
    }
  },
  computed: {
    ...mapGetters([
      "currentUserProperty",
      "program"
      //   "destinationTypes",
      //   "live",
      //   "liveDestinations",
    ])
  }
};
</script>
